<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-card flat>
                <v-card-text>
                        <!-- 심사 위원 영역 -->
                        <v-row>
                            <v-col>
                                <h4>결과: {{ finalReview.result_type.name }}</h4>
                                <hr class="mt-2 mb-2">
                                <simple-table-content :columns="reviewerTableColumns" :data="finalReview.reviews"></simple-table-content>
                            </v-col>
                        </v-row>

                    <!-- 게재 여부 영역 -->
                    <!-- <v-row>
                        <v-col>
                            <h4>{{ titles.result }}</h4>
                            <hr class="mt-2 mb-2">

                        <div class="radio-container">
                            <div v-for="(option, index) in options" :key="index">
                                <input type="radio" name="result" :value="option.idx" :checked="finalReview.result_type.idx" disabled> {{ option.label }}
                            </div>
                            </div>
                        </v-col>
                    </v-row> -->

                    <!-- 총평 내용 영역 -->
                    <v-row>
                        <v-col>
                        <h4 class="mt-3">{{ titles.comment }}</h4>
                            <v-textarea class="mt-3" :value="finalReview.comment" readonly outlined></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <!-- 심사 상세보기 모달 -->
            <card-modal v-if="showReviewerDetailModal">
                <template v-slot:body>
                    <p>{{ currentReviewer.comment }} </p>
                </template>
                <template v-slot:footer>
                    <custom-button color="black" @click="controlReviewerCommentModal" label="닫기" rounded gradient> </custom-button>
                </template>
            </card-modal>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import SimpleTableContent from '@/components/Tables/SimpleTableContent.vue';
    import CardModal from '@/components/common/Modal/CardModal.vue';
    import CustomButton from '@/components/common/buttons/CustomButton.vue';

    import { finalResultOptions } from '@/views/FinalReviewView/fields';
    import { getReviewerResultColumns } from '@/views/FinalReviewView/columns';
    import { editFinalReviewLabel } from '@/views/FinalReviewView/label';


    export default {
        name: "show-paper-review",
        components: {
            SimpleTableContent,
            CardModal,
            CustomButton,
        },
        props: {
            finalReview: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                titles: editFinalReviewLabel.titles,

                // fields & columns
                reviewerTableColumns: getReviewerResultColumns({
                    "description": this.showReviewDetail,
                }),
                options: finalResultOptions,

                // boolean
                showReviewerDetailModal: false,

                // init data
                currentReviewer: null,
            }
        },
        methods: {
            controlReviewerCommentModal() {
                this.showReviewerDetailModal = !this.showReviewerDetailModal;
            },
            showReviewDetail(reviewer) {
                if (reviewer.status === "COMPLETED") {
                    this.currentReviewer = reviewer;
                    this.controlReviewerCommentModal();
                } else {
                    this.notifyVue({alertMessage: '심사가 끝나지 않았습니다.', color: 'warning'});
                }
            },
            notifyVue({verticalAlign = 'top', horizontalAlign = 'center', alertMessage, color = 'danger'}) {
                this.$notify({
                    timeout: 3000,
                    message: alertMessage,
                    icon: "priority_high",
                    type: color,
                    horizontalAlign: horizontalAlign,
                    verticalAlign: verticalAlign,
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    $font-color: #424242;

    .section {
        margin-bottom: 50px;
    }

    h4 {
        font-weight: bold;
        color: $font-color;
        margin-bottom: -2px;
    }

    hr {
        border: 1px solid rgba(233, 233, 233, 0.5);
    }

    .download-button {
        width: 70px;
        height: 30px;
        margin-top: 15px;
    }

    .first-section-header {
        display: flex;
        justify-content: space-between;
    }

    .first-section-label {
        font-weight: 600;
        color: $font-color;
        min-width: 120px;
    }

    .text-container {
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
    }

    .text-box {
        font-family: 'KoPubWorldDotum', 'Roboto', 'Helvetica', 'Arial';
        border: 1px solid #ddd;
        color: #565656;
        width: 100%;
        height: 250px;
        resize: none;
        overflow: auto;
        margin-top: 10px;
    }

    .score {
        display: flex;
        justify-self: flex-end;
        font-weight: bold;
        font-size: medium;
        padding-right: 50px;
    }

    .radio-container {
        display: flex;
        justify-content: space-between;
    }

    .bottom-button-container {
        display: flex;
        justify-content: space-between;
    }


    .file-download:hover {
        color: #0056b3;
        text-decoration: none;
    }

    .file-download:focus {
        outline: none;
    }
</style>